import { render } from "./mini.vue?vue&type=template&id=42b7587b"
import script from "./mini.vue?vue&type=script&lang=js"
export * from "./mini.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__